import React from 'react';
import {Skeleton, Card, Collapse} from 'antd';

const {Panel} = Collapse;

function CriteriaSidebarSkeleton({viewMode = 'cards', sectionsCount = 3, itemsPerSection = 4}) {

    const renderCardsSkeleton = () => (
        <Collapse
            defaultActiveKey={Array.from({length: sectionsCount}, (_, i) => `section-${i}`)}
            bordered={false}
            expandIconPosition="right"
            style={{backgroundColor: 'transparent'}}
        >
            {Array.from({length: sectionsCount}).map((_, sectionIndex) => (
                <Panel
                    header={
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <Skeleton.Input
                                active
                                size="small"
                                style={{width: 120, height: 16}}
                            />
                            <Skeleton.Input
                                active
                                size="small"
                                style={{width: 60, height: 14, marginLeft: 8}}
                            />
                        </div>
                    }
                    key={`section-${sectionIndex}`}
                    style={{
                        marginBottom: 24,
                        backgroundColor: '#fff',
                        borderRadius: 8,
                        border: '1px solid #f0f0f0',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                    }}
                >
                    <div style={{display: 'grid', gridTemplateColumns: '1fr', gap: 16}}>
                        {Array.from({length: itemsPerSection}).map((_, itemIndex) => (
                            <Card
                                key={`card-${sectionIndex}-${itemIndex}`}
                                size="small"
                                bodyStyle={{padding: 16}}
                                style={{
                                    border: '1px solid #f0f0f0',
                                    borderRadius: 8
                                }}
                            >
                                <div style={{display: 'flex', alignItems: 'flex-start', gap: 12}}>
                                    {/* Checkbox skeleton */}
                                    <Skeleton.Button
                                        active
                                        size="small"
                                        shape="square"
                                        style={{width: 16, height: 16, minWidth: 16}}
                                    />

                                    <div style={{flex: 1}}>
                                        {/* Title and status row */}
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'flex-start',
                                            marginBottom: 8
                                        }}>
                                            <Skeleton.Input
                                                active
                                                size="small"
                                                style={{width: '70%', height: 16}}
                                            />
                                            <Skeleton.Button
                                                active
                                                size="small"
                                                style={{width: 60, height: 20, borderRadius: 4}}
                                            />
                                        </div>

                                        {/* Description */}
                                        <div style={{marginBottom: 8}}>
                                            <Skeleton.Input
                                                active
                                                size="small"
                                                style={{width: '90%', height: 14, marginBottom: 4}}
                                            />

                                        </div>

                                        {/* Creator */}
                                        <Skeleton.Input
                                            active
                                            size="small"
                                            style={{width: 100, height: 12}}
                                        />

                                        {/* Reset button (randomly show for some items) */}
                                        {Math.random() > 0.7 && (
                                            <div style={{marginTop: 8, display: 'flex', justifyContent: 'flex-end'}}>
                                                <Skeleton.Button
                                                    active
                                                    size="small"
                                                    style={{width: 60, height: 24}}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Card>
                        ))}
                    </div>
                </Panel>
            ))}
        </Collapse>
    );

    const renderListSkeleton = () => (
        <Collapse
            defaultActiveKey={Array.from({length: sectionsCount}, (_, i) => `section-${i}`)}
            bordered={false}
            expandIconPosition="right"
            style={{backgroundColor: 'transparent'}}
        >
            {Array.from({length: sectionsCount}).map((_, sectionIndex) => (
                <Panel
                    header={
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <Skeleton.Input
                                active
                                size="small"
                                style={{width: 120, height: 16}}
                            />
                            <Skeleton.Input
                                active
                                size="small"
                                style={{width: 60, height: 14, marginLeft: 8}}
                            />
                        </div>
                    }
                    key={`section-${sectionIndex}`}
                    style={{
                        marginBottom: 16,
                        backgroundColor: '#fff',
                        borderRadius: 8,
                        border: '1px solid #f0f0f0',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                    }}
                >
                    {Array.from({length: itemsPerSection}).map((_, itemIndex) => (
                        <div
                            key={`list-${sectionIndex}-${itemIndex}`}
                            style={{
                                padding: '8px 16px',
                                display: 'flex',
                                alignItems: 'center',
                                borderBottom: itemIndex < itemsPerSection - 1 ? '1px solid #f0f0f0' : 'none'
                            }}
                        >
                            {/* Checkbox */}
                            <Skeleton.Button
                                active
                                size="small"
                                shape="square"
                                style={{width: 16, height: 16, marginRight: 12, minWidth: 16}}
                            />

                            {/* Title */}
                            <Skeleton.Input
                                active
                                size="small"
                                style={{flex: 1, height: 16, marginRight: 12}}
                            />

                            {/* Status tag */}
                            <Skeleton.Button
                                active
                                size="small"
                                style={{width: 60, height: 20, borderRadius: 4, marginRight: 8}}
                            />


                        </div>
                    ))}
                </Panel>
            ))}
        </Collapse>
    );

    const renderTopBarSkeleton = () => (
        <div style={{
            display: "flex",
            gap: 5,
            marginBottom: 16,
            alignItems: "center"
        }}>

        </div>
    );

    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: 5}}>
            {renderTopBarSkeleton()}
            {viewMode === 'cards' ? renderCardsSkeleton() : renderListSkeleton()}
        </div>
    );
}

export default CriteriaSidebarSkeleton